<template>
<v-container>

    <v-row align="center"> <v-col>
       <v-dialog v-model="dialog" persistent max-width="600px">

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card>
              <v-card-title class="ml-3">
                <h3 class="text-h5 font-weight-bold darkBlue--text">Change Password</h3>
              </v-card-title>
              <v-card-text>
                <v-container>

                  <v-text-field
                    hide-details="auto"
                    solo
                    flat
                    v-model="strpassword"
                    :counter="50"
                    label="Type new password..."
                    required
                  ></v-text-field>
                </v-container>
              </v-card-text>
              <v-card-actions class="mr-5">
                <v-spacer></v-spacer>
                <v-btn color="#51A7F8" depressed @click="goTo('/allapps')">
                  <span class="font-weight-bold body-1 white--text text-capitalize">Close</span>
                </v-btn>
                <v-btn
                  :disabled="strpassword.length < 6"
                  color="#51A7F8"
                  depressed
                  @click="updatepassword()"
                >
                  <span class="font-weight-bold body-1 white--text text-capitalize">Save</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        </v-col>
    </v-row>

</v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from '../../../apis/apifactory';

Vue.use(VueAxios, axios);
export default {
    name: "ExtraAuth",
    data: () => ({
dialog:true,
        userid: null,
        strpassword: '',
        msg: ''

    }),
    computed: {
        appitemfirst() {
            return this.appItems.length;
        }
    },
    mounted() {
     this.getstoragevalues();
    },
    methods: {
       getstoragevalues() {
      this.userid = localStorage.getItem("SET_USERID");
    },
updatepassword(){
         //alert(this.userid);
         apifactory.changeuserpassword( this.userid ,this.strpassword)
                .then((res) => {
                    // alert(res.status);

                    if (res.status != 200) {
                        alert(res.data.message);

                    } else {
                        if(res.data.status == 201){
                            this.goTo('/allapps');
                        }


                    }
                })
                .catch(function (error) {
                     alert(JSON.stringify(error));
                });
    },
        goTo(url) {

           return this.$router.push(url);
        }

    }

};
</script>

<style scoped>
.linkdiv {

    cursor: pointer;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f3f5f8 !important;
  border-radius: 8px !important;
  font-weight: 700;
}
</style>
